/* eslint-disable @typescript-eslint/no-explicit-any */
import { IEvent, IEventsPagination } from '@interfaces/IEvent';
import { IEventsQParams } from '@interfaces/IEventsQParams';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { Action } from '@ngrx/store';

export enum EEventsViewActions {
  GetEventRequest = '[Events-view] Get Event Request',
  GetEventSuccess = '[Events-view] Get Event Success',
  GetEventFailure = '[Events-view] Get Event Failure',

  GetEventsByPeriodRequest = '[Events-view] Get Events By Period Request',
  GetEventsByPeriodSuccess = '[Events-view] Get Events By Period Success',
  GetEventsByPeriodFailure = '[Events-view] Get Events By Period Failure',
  ClearGetEventsByPeriod = '[Events] Clear Get Events By Period',

  GetEventsRequest = '[Events-view] Get Events Request',
  GetEventsSuccess = '[Events-view] Get Events Success',
  GetEventsFailure = '[Events-view] Get Events Failure',
  ClearEvents = '[Events-view] Clear Events',

  GetVideoLinkRequest = '[Events-view] Get Video Link Request',
  GetVideoLinkSuccess = '[Events-view] Get Video Link Success',
  GetVideoLinkFailure = '[Events-view] Get Video Link Failure',

  SetCurrentEvent = '[Events-view] Set Current Event',
  ClearCurrentEvent = '[Events-view] Clear Current Event',
}

export class GetEventRequest implements Action {
  public readonly type = EEventsViewActions.GetEventRequest;

  constructor(public payload: number) {}
}

export class GetEventSuccess implements Action {
  public readonly type = EEventsViewActions.GetEventSuccess;

  //TODO Альбина должна переделать и убрать any. Чтобы когда убрать eslint-disable линтер не ругался
  constructor(public payload: IEvent | any) {}
}

export class GetEventFailure implements Action {
  public readonly type = EEventsViewActions.GetEventFailure;

  constructor(public payload: IFormErrors) {}
}

export class GetEventsByPeriodRequest implements Action {
  public readonly type = EEventsViewActions.GetEventsByPeriodRequest;

  constructor(public periodId: number) {}
}

export class GetEventsByPeriodSuccess implements Action {
  public readonly type = EEventsViewActions.GetEventsByPeriodSuccess;

  constructor(public events: IEvent[]) {}
}

export class GetEventsByPeriodFailure implements Action {
  public readonly type = EEventsViewActions.GetEventsByPeriodFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetEventsByPeriod implements Action {
  public readonly type = EEventsViewActions.ClearGetEventsByPeriod;
}

export class GetEventsRequest implements Action {
  public readonly type = EEventsViewActions.GetEventsRequest;

  constructor(public qParams: IEventsQParams) {}
}

export class GetEventsSuccess implements Action {
  public readonly type = EEventsViewActions.GetEventsSuccess;

  constructor(public payload: IEventsPagination) {}
}

export class GetEventsFailure implements Action {
  public readonly type = EEventsViewActions.GetEventsFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearEvents implements Action {
  public readonly type = EEventsViewActions.ClearEvents;
}

export class SetCurrentEvent implements Action {
  public readonly type = EEventsViewActions.SetCurrentEvent;

  constructor(public event: IEvent | null) {}
}

export class ClearCurrentEvent implements Action {
  public readonly type = EEventsViewActions.ClearCurrentEvent;
}

export class GetVideoLinkRequest implements Action {
  public readonly type = EEventsViewActions.GetVideoLinkRequest;

  constructor(public eventId: number) {}
}
export class GetVideoLinkSuccess implements Action {
  public readonly type = EEventsViewActions.GetVideoLinkSuccess;
}
export class GetVideoLinkFailure implements Action {
  public readonly type = EEventsViewActions.GetVideoLinkFailure;
}

export type EventsViewActions =
  | GetEventRequest
  | GetEventSuccess
  | GetEventFailure
  | GetEventsRequest
  | GetEventsSuccess
  | GetEventsFailure
  | ClearEvents
  | GetEventsByPeriodRequest
  | GetEventsByPeriodSuccess
  | GetEventsByPeriodFailure
  | ClearGetEventsByPeriod
  | SetCurrentEvent
  | ClearCurrentEvent
  | GetVideoLinkRequest
  | GetVideoLinkSuccess
  | GetVideoLinkFailure;
